export default "__VITE_ASSET__BRYj$zMn__"